import {
  getLeoUuid,
  LeoUUID,
  getObject,
  getBoolean,
  getList,
} from "@surya-digital/leo-ts-types";
import { Order, OrderDTO } from "../types/order";
import { GroupChildVisibility, GroupChildVisibilityDTO } from "./groupChildVisibility";

export interface SurveyQuestionViewOrderDTO {
  surveyQuestionViewId: string;
  order: OrderDTO;
  isViewVisible: boolean;
  groupChildViewVisibilities: GroupChildVisibilityDTO[];
}

export class SurveyQuestionViewOrder {
  readonly isSurveyQuestionViewOrderSurveyQuestionViewOrder: boolean = true;

  readonly surveyQuestionViewId: LeoUUID;
  readonly order: Order;
  readonly isViewVisible: boolean;
  readonly groupChildViewVisibilities: GroupChildVisibility[];


  constructor(
  surveyQuestionViewId: LeoUUID, 
  order: Order, 
  isViewVisible: boolean, 
  groupChildViewVisibilities: GroupChildVisibility[]
  ) {
    this.surveyQuestionViewId = surveyQuestionViewId;
    this.order = order;
    this.isViewVisible = isViewVisible;
    this.groupChildViewVisibilities = groupChildViewVisibilities;
  }

  static fromDTO(dto: SurveyQuestionViewOrderDTO): SurveyQuestionViewOrder {
    const surveyQuestionViewId = getLeoUuid(dto, "surveyQuestionViewId", InvalidSurveyQuestionViewOrderSurveyQuestionViewIdError);
    const order = Order.fromDTO(getObject(dto, "order", InvalidSurveyQuestionViewOrderOrderError));
    const isViewVisible = getBoolean(dto, "isViewVisible", InvalidSurveyQuestionViewOrderIsViewVisibleError);
    const groupChildViewVisibilities = getList<GroupChildVisibilityDTO, GroupChildVisibility>(
      dto,
      "groupChildViewVisibilities",
      GroupChildVisibility.fromDTO,
      InvalidSurveyQuestionViewOrderGroupChildViewVisibilitiesError
    );
    return new SurveyQuestionViewOrder(
      surveyQuestionViewId,
      order,
      isViewVisible,
      groupChildViewVisibilities
    );
  }

  toDTO(): SurveyQuestionViewOrderDTO {
    const dto: SurveyQuestionViewOrderDTO = {
        surveyQuestionViewId: this.surveyQuestionViewId.toDTO(),
        order: this.order.toDTO(),
        isViewVisible: this.isViewVisible,
        groupChildViewVisibilities: this.groupChildViewVisibilities.map((e: GroupChildVisibility) => { return e.toDTO() })
    };
    return dto;
  }
  }

SurveyQuestionViewOrder.prototype.toString = function toString(): string {
  return `SurveyQuestionViewOrder(surveyQuestionViewId='${this.surveyQuestionViewId}',order='${this.order}',isViewVisible='${this.isViewVisible}',groupChildViewVisibilities='${this.groupChildViewVisibilities}')`;
};

export class InvalidSurveyQuestionViewOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyQuestionViewOrderError";
  }
}
export class InvalidSurveyQuestionViewOrderSurveyQuestionViewIdError extends InvalidSurveyQuestionViewOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyQuestionViewOrderSurveyQuestionViewIdError";
  }
}

export class InvalidSurveyQuestionViewOrderOrderError extends InvalidSurveyQuestionViewOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyQuestionViewOrderOrderError";
  }
}

export class InvalidSurveyQuestionViewOrderIsViewVisibleError extends InvalidSurveyQuestionViewOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyQuestionViewOrderIsViewVisibleError";
  }
}

export class InvalidSurveyQuestionViewOrderGroupChildViewVisibilitiesError extends InvalidSurveyQuestionViewOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyQuestionViewOrderGroupChildViewVisibilitiesError";
  }
}
